/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Planning_Vakanties_Vrije_DagInputs */

const nl_planning_vakanties_vrije_dag = /** @type {(inputs: Planning_Vakanties_Vrije_DagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vrije dag`)
};

/**

* @param {Planning_Vakanties_Vrije_DagInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const planning_vakanties_vrije_dag = /** @type {((inputs?: Planning_Vakanties_Vrije_DagInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planning_Vakanties_Vrije_DagInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_planning_vakanties_vrije_dag(inputs)
});
export { planning_vakanties_vrije_dag as "planning.vakanties.vrije_dag" }